export const REST_URLS = {
  STORE_LIST: "/v1/central-service/stores/public",
  STATE_CITIES_LIST: "/v1/central-service/stores/p/store-master",
  SEND_OTP: "/v1/central-service/users/send-otp",
  VERIFY_OTP: "/v1/central-service/users/verify-otp",
};
// export const HOSTNAME = `http://localhost:5000`;
export const HOSTNAME = `https://api.mysubway.in`;
